import { Injectable } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Storage, RouteName } from '../../shared/constants';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../shared/authentication/authentication.service';

@Injectable()
export class SumtInterceptor implements HttpInterceptor {
  constructor(private translate: TranslateService,
    // private auth: AuthenticationService,
    private locationStrategy: LocationStrategy
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.getToken();
    if (this.isTokenExpired(token)) {
      window.localStorage.removeItem(Storage.AUTH_TOKEN);
      window.location.href = this.locationStrategy.getBaseHref() + RouteName.SIGNIN;
      return;
    }

    let interceptedReq = req.clone({ url: this.updateUrl(req.url), setHeaders: { 'Accept-Language': this.getLangaugeHeader(token) } });

    if (req.url && (req.url.indexOf(window.localStorage.getItem(Storage.AUTH_URL)) >= 0
    || req.url.indexOf(window.localStorage.getItem(Storage.LOGIN_URL)) >= 0
    || req.url.indexOf(window.localStorage.getItem(Storage.RESET_PASSWORD_URL)) >= 0)) {
      interceptedReq = interceptedReq.clone({ setHeaders: { 'Content-Type': 'application/x-www-form-urlencoded' } });
    } else if (token) {
      interceptedReq = interceptedReq.clone({ setHeaders: { 'sumtauth-header': token } });
    }
    return next.handle(interceptedReq);
  }

  private updateUrl(url: string) {
    return (url.startsWith('http') ? url : this.formatUrl(url));
  }

  private formatUrl(path: string): string {
    return window.location.protocol + '//' + window.location.hostname + '/services/api' + (path.startsWith('/') ? '' : '/') + path;
  }

  private getLangaugeHeader(token: string) {
    const parsedToken = this.parseToken(token);
    let currentCulture;
    if (parsedToken) {
      currentCulture = parsedToken['cul'];
    } else if (window.localStorage.getItem(Storage.CULTURE)) {
      currentCulture = window.localStorage.getItem(Storage.CULTURE);
    } else {
      currentCulture = this.translate.getBrowserCultureLang();
    }
    return currentCulture || 'en-US';
  }

  public isTokenExpired(token: string) {
    const jwtPayload = this.parseToken(token);
    if (jwtPayload) {
      const ticksTill1970 = 621355968000000000;
      return Date.now() * 10000 > (jwtPayload.exp - ticksTill1970);
    }
    return false;
  }

  public getToken() {
    return window.localStorage.getItem(Storage.AUTH_TOKEN);
  }

  public parseToken(token: string) {
    if (token && token !== 'null') {
      const payload = token.split('.')[1].replace('-', '+').replace('_', '/');
      return JSON.parse(window.atob(payload));
    }
    return null;
  }
}

export const HTTP_OVERRIDE_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: SumtInterceptor,
  multi: true
};



// WEBPACK FOOTER //
// ../UI/src/app/core/http/sumt.interceptor.ts